import * as React from 'react'
import { createPortal } from 'react-dom'
import { NavigationItem } from '../NavigationItem'
import logoImage from '../../../images/pdftools-logo.svg'
import { useI18n } from '../../../lib/context/i18n'
import { defaultLanguage } from '../../../../config/storyblok/languages'
import { formatPath } from '../../../lib/utils/internalLinks'
import {
  ContainerInner,
  GlobalVariableStyle,
  StyledDropdownBackdrop,
  StyledItems,
  StyledLogo,
  StyledLogoLink,
  StyledNav,
  StyledWrapper,
} from './styled'
import { DesktopNavigationProps } from './types'

export const DesktopNavigation = ({ data }: DesktopNavigationProps) => {
  const [isScrolled, setIsScrolled] = React.useState(false)
  const [menuOpen, setMenuOpen] = React.useState(false)
  const { getTranslatedUrlFromLink, currentLanguage } = useI18n()

  const onMouseEnter = () => {
    setMenuOpen(true)
  }

  const onMouseLeave = () => {
    setMenuOpen(false)
  }

  const BackdropPortal =
    typeof document !== 'undefined' ? createPortal(<StyledDropdownBackdrop active={menuOpen} />, document.body) : null

  React.useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolled(true)
      } else {
        setIsScrolled(false)
      }
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const homeRoute = formatPath(`/${currentLanguage !== defaultLanguage ? currentLanguage : '/'}`)

  return (
    <>
      <GlobalVariableStyle />
      <StyledWrapper isScrolled={isScrolled}>
        <ContainerInner>
          <StyledItems>
            <StyledLogoLink to={homeRoute}>
              <StyledLogo src={logoImage} alt="PDF Tools Logo" />
            </StyledLogoLink>
            <nav>
              <StyledNav>
                {data.primary_navigation?.map((item, i) => (
                  <NavigationItem
                    onMouseEnter={item.dropdown && item.dropdown.length > 0 ? onMouseEnter : undefined}
                    onMouseLeave={onMouseLeave}
                    to={getTranslatedUrlFromLink(item.link)}
                    label={item.label}
                    dropdown={item.dropdown}
                    key={`primary-navigation-${i}_${item.link.id}`}
                  />
                ))}
              </StyledNav>
            </nav>
          </StyledItems>
          <StyledItems right>
            <nav>
              <StyledNav>
                {data.secondary_navigation?.map((item, i) => (
                  <NavigationItem
                    onMouseEnter={!!item.children ? onMouseEnter : undefined}
                    onMouseLeave={onMouseLeave}
                    to={getTranslatedUrlFromLink(item.link)}
                    label={item.label}
                    dropdown={item.dropdown}
                    key={`secondary-navigation-${i}_${item.link.id}`}
                    $inverted={item.inverted}
                  />
                ))}

                {/* get started */}
                {!!data.get_started && !!data.get_started[0] && (
                  <NavigationItem
                    to={getTranslatedUrlFromLink(data.get_started[0].link)}
                    label={data.get_started[0].label}
                    $inverted
                  />
                )}
                {!!data.contact_button && !!data.contact_button[0] && (
                  <NavigationItem
                    to={getTranslatedUrlFromLink(data.contact_button[0].link)}
                    label={data.contact_button[0].label}
                    $bordered={true}
                  />
                )}
              </StyledNav>
            </nav>
          </StyledItems>
        </ContainerInner>
      </StyledWrapper>
      {BackdropPortal}
    </>
  )
}
